import { render } from "./Logo.vue?vue&type=template&id=18b05425&scoped=true"
import script from "./Logo.vue?vue&type=script&lang=js"
export * from "./Logo.vue?vue&type=script&lang=js"

import "./Logo.vue?vue&type=style&index=0&id=18b05425&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/fast-blockchains-dashboard/fast-blockchains-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18b05425"]])

export default __exports__